module.exports = __webpack_public_path__ + "img/drt2.bc3be70e.png";